import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";
import { api, fetcher } from "services/api.service";
import { LocationManagementLocationKind } from "types/locationManagement/locationKind";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async ({ params }: LoaderFunctionArgs) => {
  const { locationKindId } = params;
  const locationKind = await fetcher<LocationManagementLocationKind>(
    `/location_management/location_kinds/${locationKindId}`,
  );
  return { locationKind };
});

export async function action({ params, request }: ActionFunctionArgs) {
  const fd = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "PUT",
      url: `/location_management/location_kinds/${params.locationKindId}`,
      data: fd,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 200) {
    return redirect("/location-kinds");
  }
  return res;
}
